export default "__VITE_ASSET__DxjJu1N3__"